import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';
import data from './data';
import axiosInstance from '../../../axios-orders';
import { isNull } from 'lodash-es';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CustomerListView = () => {
  const classes = useStyles();
  const [customers,setCustomers] = useState(null);
  const [statistic,setStatistic] = useState(null);
  const [result,setResult] = useState(null);
 
  useEffect(() => {
    let  token  = JSON.parse(localStorage.getItem('user'));
    axiosInstance().get('/api/homologation/users/me').then(res => {
        const customers = res.data;
        setCustomers(customers);       
      });
      axiosInstance().get('/api/statistic/users/me').then(res => {
        const statistic = res.data;
        setStatistic(statistic); 
            
      });    
      
}, []);

const ResultsList = () =>{  
  let array1=[];
  let array2=[];
  let resul=[];
  var object= new Object(); 
/*if(!isNull(customers)){
  array1 =customers.map((customer) => (
    object.firstname = customer.masterTile ,
    object.masterTitle = customer.type ,
    object.state = customer.state,
    object.procedureDate = customer.procedureDate
  ));
  console.log(array1); 
}
if(!isNull(statistic)){
  array2 =statistic.map((customer) => (
    object.firstname = customer.FirstName ,
    object.masterTitle = customer.type ,
    object.state = customer.state,
    object.procedureDate = customer.procedureDate
  ));
  console.log(array2); 
}*/
if(!isNull(customers) && !isNull(statistic)){
console.log(customers.concat(statistic));
return customers.concat(statistic); 

}
if(!isNull(customers)&& isNull(statistic)){
  return customers;
}
if(!isNull(statistic)&& isNull(customers)){
  return statistic;
}
 return;
}


  return (
    <Page
      className={classes.root}
      title="Mis Trámites"
    >
      <Container maxWidth={false}>
       
        <Box mt={3}>
          <Results customers={ResultsList()} />
        </Box>
      </Container>
    </Page>
  );
};

export default CustomerListView;
